import { InfiniteSlider } from '@/components/ui/infinite-slider';
import { cn } from '@/lib/utils';

export function LogoCloud({ className, logos, ...props }) {
  return (
    <div
      {...props}
      className={cn(
        'overflow-hidden py-4 [mask-image:linear-gradient(to_right,transparent,black,transparent)]',
        className,
      )}
    >
      <InfiniteSlider gap={56} reverse duration={40} durationOnHover={80}>
        {logos.map((logo) => (
          <div
            key={`logo-${logo.alt}`}
            className="flex h-8 items-center justify-center whitespace-nowrap px-4 text-sm font-semibold tracking-tight text-foreground/70 md:h-9 md:text-base"
          >
            {logo.label || logo.alt}
          </div>
        ))}
      </InfiniteSlider>
    </div>
  );
}
